var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 24.2579,
    fill: "#FF3333",
    stroke: "white",
    strokeWidth: 2.48424
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5458 12.297L12.2634 15.5794L22.1107 25.4268L12.2634 35.2741L15.5458 38.5565L25.3931 28.7092L35.2405 38.5565L38.5229 35.2741L28.6756 25.4268L38.5229 15.5794L35.2405 12.297L25.3931 22.1443L15.5458 12.297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.86c24ad5226e4c368ba0d353edf80e1a.svg";
export { ForwardRef as ReactComponent };